<template>
  <pt-feedback-manage class="pt-feedback-manage__withData"></pt-feedback-manage>
</template>

<script>
import PtFeedbackManage from './index'
export default {
  name: 'pt-feedback-manage__withData',
  components: {
    'pt-feedback-manage': PtFeedbackManage
  }
}
</script>
